import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Organization } from './organization';
import { OrganizationRider } from './organization-rider';
import { RideRequest } from './ride-request';
import { VehicleType } from './vehicle-type';
import { AbstractModel } from './abstract-model';

@inheritSerialization(AbstractModel)
export class Itinerary extends AbstractModel {
  @autoserializeAs(Organization)
  organization: Organization;

  @autoserialize
  partnerIdentifier: string;

  @autoserializeAs(OrganizationRider)
  organizationRider: OrganizationRider;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserialize
  riderPaymentAccountId: number;

  @autoserializeAs(VehicleType)
  vehicleType: VehicleType;

  // TODO: Remove if this doesn't have an issue
  // @autoserializeAs(Amenity)
  // amenities: Array<Amenity>;

  @autoserializeAs(RideRequest)
  rideRequests: Array<RideRequest>;

  @autoserialize
  createdByUserId: number;

  static OnSerialized(instance: Itinerary, json: any): void {
    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeLocalDate(instance.pickupDate);
    }
  }

  static OnDeserialized(instance: Itinerary, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeLocalDate(json['pickupDate']);
    }
  }
}
